// extracted by mini-css-extract-plugin
module.exports = {"container":"inOutCanvas_container__1axXE","background":"inOutCanvas_background__RRW1s","buttonBar":"inOutCanvas_buttonBar__540MH"};